<script setup lang="ts">
import { ref, watchEffect, onMounted, nextTick } from "vue";
import SVGDown from "../svg/SVGDown.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { SVGDown },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    initOpen?: boolean;
    titleHeight?: string;
    bgColor?: string;
    fontColor?: string;
    borderColor?: string;
    borderRadius?: string;
    padding?: string;
    duration?: number;
  }>(),
  {
    initOpen: false,
    titleHeight: "44px",
    bgColor: "#efefef",
    fontColor: "#333333",
    borderColor: "#dddddd",
    borderRadius: "4px",
    padding: "1em",
    duration: 500
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const open = ref(true);

const content = ref();
const contentMaxHeight = ref(Number.MAX_SAFE_INTEGER + "px");

function computeHeight() {
  if (content.value) {
    contentMaxHeight.value =
      content.value.getBoundingClientRect().height + "px";
  }
}

onMounted(() => {
  nextTick(() => {
    computeHeight();
    open.value = props.initOpen;
  });
});

function toggleOpen() {
  open.value = !open.value;
  if (open.value) {
    emits("open");
  } else {
    emits("close");
  }
}

const rotate = ref(0);
watchEffect(() => {
  rotate.value = open.value ? 0 : -90;
});

// 当子组件是异步组件，例如 Image 时，等 Image.mount 后再重新计算高度
const reset = () => {
  computeHeight();
};

defineExpose({ reset });
</script>

<template>
  <div>
    <div
      class="accordion"
      :style="{
        background: props.bgColor,
        color: props.fontColor,
        borderRadius: props.borderRadius
      }"
    >
      <div
        class="accordion-title"
        @click="toggleOpen"
        :style="{
          height: props.titleHeight,
          lineHeight: props.titleHeight,
          margin: `0 ${props.padding}`,
          transitionDelay: `${open ? 0 : props.duration}ms`,
          borderBottom: `${open ? 1 : 0}px solid ${props.borderColor}`
        }"
      >
        <slot name="title">title</slot>
        <SVGDown
          class="arrow"
          :style="{
            transition: `transform ${props.duration}ms ease-in-out`,
            transform: `rotate(${rotate}deg)`
          }"
        ></SVGDown>
      </div>

      <div
        class="accordion-content"
        ref="content"
        :style="{
          margin: `0 ${props.padding}`,
          transition: `max-height ${props.duration}ms ease-in-out`,
          maxHeight: open ? contentMaxHeight : '0'
        }"
      >
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.accordion {
  width: 100%;
  font-size: 1em;
  position: relative;
  overflow: hidden;
}
.accordion-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  cursor: pointer;
}
.accordion-content {
  word-break: break-all;
  overflow: hidden;
}
</style>
